//TODO: Refactoring All Project
//TODO: fix naming
//TODO: Refactoring actions
//TODO: Refactoring components
//TODO: Refactoring All Services (methods)
//TODO: Fix naming - variables(and actions)

import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'

import App from './App'
import store from './redux'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('.admin-wrapper'),
)
